import { Api } from 'utils';

class UsersService {
	
	static get = async (params?: any) => Api.createResponse('admin/users/get',params);
	static updatePatient = async (params?: any) => Api.createResponse('admin/users/patient/update',params);
	static deletePatient = async (params?: any) => Api.createResponse('admin/users/patient/delete',params);
	static updateDoctor = async (params?: any) => Api.createResponse('admin/users/doctor/update',params);
	static updateCompany = async (params?: any) => Api.createResponse('admin/users/company/update',params);
	static approveDoctor = async (params?: any) => Api.createResponse('admin/users/doctor/approve',params);
	static rejectDoctor = async (params?: any) => Api.createResponse('admin/users/doctor/reject',params);
	static disableDoctor = async (params?: any) => Api.createResponse('admin/users/doctor/disable',params);
	static enableDoctor = async (params?: any) => Api.createResponse('admin/users/doctor/enable',params);

}

export default UsersService;